'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';

function calcPadding(_ref) {
  var isReady = _ref.isReady,
      placeholderAspectRatio = _ref.placeholderAspectRatio;
  return isReady ? '0' : (100 / placeholderAspectRatio).toFixed(2).toString();
}

var Padding = styled.div.withConfig({
  displayName: "Wrapper__Padding",
  componentId: "sc-1hzbtvh-0"
})(["position:relative;padding-top:", "%;background-color:", ";"], calcPadding, function (props) {
  return props.loadingBackground || '';
});
var Container = styled.div.withConfig({
  displayName: "Wrapper__Container",
  componentId: "sc-1hzbtvh-1"
})(["position:", ";top:0;height:100%;width:100%;"], function (props) {
  return props.isReady ? 'relative' : 'absolute';
});
export default (function (props) {
  return /*#__PURE__*/_jsx(Padding, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(Container, {
      isReady: props.isReady,
      children: props.children
    })
  }));
});